<script lang="ts">
  import { SquareCheck, SquareX } from "lucide-svelte"

  let { role }: { role: RoleType } = $props()

  const permissions = [
    {
      feature: "Manage Billing",
      admin: true,
      leader: false,
      manager: false,
      member: false,
      recognition: false
    },
    {
      feature: "Manage One Page View",
      admin: true,
      leader: true,
      manager: false,
      member: false,
      recognition: false
    },
    {
      feature: "Leadership-Only Notes",
      admin: true,
      leader: true,
      manager: false,
      member: false,
      recognition: false
    },
    {
      feature: "Transition Meetings",
      admin: true,
      leader: true,
      manager: true,
      member: false,
      recognition: false
    },
    {
      feature: "Manage Goals",
      admin: true,
      leader: true,
      manager: true,
      member: false,
      recognition: false
    },
    {
      feature: "View Goals",
      admin: true,
      leader: true,
      manager: true,
      member: true,
      recognition: false
    },

    {
      feature: "Manage Tasks",
      admin: true,
      leader: true,
      manager: true,
      member: true,
      recognition: false
    },
    {
      feature: "Activity Page",
      admin: true,
      leader: true,
      manager: true,
      member: true,
      recognition: false
    },
    {
      feature: "University",
      admin: true,
      leader: true,
      manager: true,
      member: true,
      recognition: false
    },
    {
      feature: "Recognitions",
      admin: true,
      leader: true,
      manager: true,
      member: true,
      recognition: true
    },
    {
      feature: "Community",
      admin: true,
      leader: true,
      manager: true,
      member: true,
      recognition: true
    }
  ]
</script>

{#if role}
  <div class="grid grid-cols-1 gap-x-2 border-b border-gray-200 py-2 px-2 mb-2">
    <div class="text-ms font-bold text-center px-1 col-span-2 text-tertiary">
      Feature List
    </div>
  </div>
  {#each permissions as permission}
    <div
      class="grid grid-cols-4 gap-x-0.5 py-0.5 px-2 font-semibold text-blue-800 text-sm"
    >
      <div class="col-span-3">
        {permission.feature}
      </div>
      <div class="flex items-center justify-end">
        {#if role == "admin"}
          {#if permission.admin}
            <SquareCheck class="text-green-500 w-4 h-4" />
          {:else}
            <SquareX class="text-red-500 w-4 h-4" />
          {/if}
        {:else if role == "leader"}
          {#if permission.leader}
            <SquareCheck class="text-green-500 w-4 h-4" />
          {:else}
            <SquareX class="text-red-500 w-4 h-4" />
          {/if}
        {:else if role == "manager"}
          {#if permission.manager}
            <SquareCheck class="text-green-500 w-4 h-4" />
          {:else}
            <SquareX class="text-red-500 w-4 h-4" />
          {/if}
        {:else if role == "member"}
          {#if permission.member}
            <SquareCheck class="text-green-500 w-4 h-4" />
          {:else}
            <SquareX class="text-red-500 w-4 h-4" />
          {/if}
        {:else if role == "recognition"}
          {#if permission.recognition}
            <SquareCheck class="text-green-500 w-4 h-4" />
          {:else}
            <SquareX class="text-red-500 w-4 h-4" />
          {/if}
        {/if}
      </div>
    </div>
  {/each}
{:else}
  <div class="grid grid-cols-1 py-24 px-2">
    <div class="text-ms font-bold text-center">
      Select Role to see which which features they have access to.
    </div>
  </div>
{/if}
